import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { formatDateTimeBetslip, formatDate } from '../../common/utils/formatDateTime';
import formatReturns from '../../common/utils/formatReturns';
import Svg from '../../common/svgIcon';
import SkybetLogo from '../../bookmakersSwitcher/chooseBookmakerPage/components/SkyBetLogo';

class BetHistoryListItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isToggled: false,
        };

        this.onToggleDropdown = this.onToggleDropdown.bind(this);
    }

    onToggleDropdown() {
        this.setState({
            isToggled: !this.state.isToggled,
        });
    }

    render() {
        const {
            selections,
            betType,
            bookmakerName,
            finished,
            receiptId,
            timeBetPlaced,
            totalStake,
            returns,
            estimatedReturns,
            currencySign,
            win,
            stake
        } = this.props;

        const openBetName = (betType === 'singles') ? 'Single' : betType;

        const transformCastName = (castType) => {
            switch (castType) {
                case 'straight-forecast':
                    return 'Forecast'
                case 'reverse-forecast':
                    return 'Reverse Forecast'
                case 'straight-tricast':
                    return 'Tricast'
                case 'combination-tricast':
                    return 'Combination Tricasts'
                case 'combination-forecast':
                    return 'Combination Forecasts'
                case 'accumulator-4':
                    return '4-fold'
            
                default: 
                    return openBetName
            }
        }

        const isEachWay = selections.every(selection => selection.eachWay === true);
        const betName = `${transformCastName(betType)} ${isEachWay ? 'EW' : ''}`
        const numberOfLines = Math.round(totalStake / stake)
        const timePlaced = formatDateTimeBetslip(timeBetPlaced)
        
        const parseReturns = (returnTarget) => {
            if (!returnTarget || parseFloat(returnTarget) === 0) {
                return 'N/A'
            } else {
                return `${currencySign}${formatReturns(returnTarget)}`
            }
        }

        const getOddsLabel = (odd) => {
            if (odd === '0/0' || odd === '/' || odd === null) {
                return 'SP';
            } else if (odd === '1/1') {
                return 'Evs';
            } else {
                return odd;
            }
        }

        const returnsValue = parseReturns(returns)  
        const estimatedReturnsValue = parseReturns(estimatedReturns)
        const totalStakeValue = `${currencySign}${totalStake.toFixed(2)}`

        return (
            <Fragment key={receiptId}>
                {/* Tablet++ */}
                <div className="MyBetsSingleBetContainerDesktopLayout">
                    <div className="MyBetsSingleBet">
                        <div className="MyBetsSingleBetRow MyBetsSingleBetOfferCard">
                            <div className='BookmakerLogo' data-test-selector="Logo__BetHistoryBookmaker">
                                
                                {bookmakerName === "skybet" ? 
                                    <SkybetLogo />
                                    : 
                                    <Svg iconName={bookmakerName}/>
                                }
                            </div>
                            <div className='OfferCardDetailsContainer'>
                                <div 
                                    className='MyBetsSingleBetOfferCardDetails FontSizeLarge BetStatus'
                                    data-test-selector="Text__BetStatus"
                                >
                                    {finished ? (
                                        <Fragment>
                                            {win ? (
                                                <span className="Won">WON</span>
                                            ) : 'LOST'}
                                        </Fragment>
                                    ) : (
                                        'OPEN'
                                    )}
                                </div>

                                <div 
                                    className='MyBetsSingleBetOfferCardDetails GrayColour Bold'
                                    data-test-selector="Text__BetName"
                                >
                                    { betName }
                                </div>
                            </div>
                        </div>

                        <div className='MyBetsSingleBetType MyBetsSingleBetColumn'>
                            
                            <div>
                                <span 
                                    className='TypeMultiplier'
                                    data-test-selector="Text__BetNumberOfLines"
                                >
                                    {numberOfLines}
                                </span>
                                <span> x </span>
                                {/* Stake */}
                                <span 
                                    className='TypePrice'
                                    data-test-selector="Text__BetStake"
                                >{stake.toFixed(2)}</span>
                            </div>

                            {
                                selections.length > 1 ? (
                                    <div className="MultipleSelections">
                                        <div
                                            className={
                                                classNames('MultipleSelectionsToggle',
                                                { [this.state.isToggled && 'isToggled']: this.state.isToggled })
                                            }
                                            onClick={this.onToggleDropdown}
                                            data-test-selector="Button__ToggleMultipleBetSelections"
                                        >
                                            <div className='ToggleHandle'>
                                                { this.state.isToggled ? (
                                                        <Fragment>
                                                            <Svg
                                                                key='desktop-eye-closed'
                                                                iconName="eye-closed"
                                                                className='ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
                                                            />
                                                            close selections
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            <Svg
                                                                key='desktop-eye'
                                                                iconName="eye"
                                                                className='ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
                                                            />
                                                            view selections
                                                        </Fragment>
                                                    )
                                                }
                                            </div>
                                        </div>

                                        {this.state.isToggled && (
                                            <div className="RacesContainer">
                                                {
                                                    selections.map((selection, index) => (
                                                        <div key={`desktop-${index}`} className="RaceDetails">
                                                            <div className='HorseDetails'>
                                                                <span 
                                                                    className='HorseName Bold'
                                                                    data-test-selector="Text__BetSelectionName"
                                                                >
                                                                    {selection.selectionName}
                                                                </span>
                                                                <span 
                                                                    className='GrayColour FontSizeMedium Bold'
                                                                    data-test-selector="Text__BetSelectionOdds"    
                                                                > 
                                                                    {getOddsLabel(selection.odd)}
                                                                </span>
                                                            </div>
                                                            
                                                            <div className='EventName' data-test-selector="Text__BetSelectionEvent"> {selection.eventName} - {formatDate(selection.eventDateTime)}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div className="RaceDetails"> 
                                        <div className='HorseDetails'>
                                            <span className='HorseName Bold' data-test-selector="Text__BetSelectionName">
                                                {selections[0].selectionName} 
                                            </span>
                                            <span 
                                                className='GrayColour bold' 
                                                data-test-selector="Text__BetSelectionOdds"
                                            > {getOddsLabel(selections[0].odd)}</span>
                                        </div>
                                        <div className='EventName' data-test-selector="Text__BetSelectionEvent"> {selections[0].eventName} - {formatDate(selections[0].eventDateTime)}</div>
                                    </div>
                                )
                            }
                        </div>

                        <div className="MyBetsSingleBetColumn">
                            <div className="
                                    MyBetsSingleBetRow 
                                    MyBetsSingleReturnBet
                                    MyBetsSingleBetReturnStacke">
                                <div className='MyBetsSingleBetReturnType'>STAKE</div>
                                <div 
                                    className='MyBetsSingleBetReturnAmount'
                                    data-test-selector="Text__BetTotalStake"
                                >
                                    {totalStakeValue}</div>
                            </div>

                            {
                                finished ? (
                                        win ? (
                                            <div className="MyBetsSingleBetRow">
                                                <div 
                                                    className='MyBetsSingleBetReturnType GrayColour'
                                                    data-test-selector="Text__BetWin"    
                                                >won</div>
                                                <div 
                                                    className='MyBetsSingleBetReturnAmount BetStatus Won'
                                                    data-test-selector="Text__BetReturns"    
                                                >+{returnsValue}</div>
                                            </div>
                                        ) : (
                                            <div className="MyBetsSingleBetRow">
                                                <div 
                                                    className='MyBetsSingleBetReturnType GrayColour'
                                                    data-test-selector="Text__BetLost"    
                                                >lost</div>
                                                <div 
                                                    className='MyBetsSingleBetReturnAmount'
                                                    data-test-selector="Text__BetTotalStakeValue"    
                                                >-{totalStakeValue}</div>
                                            </div>
                                        )
                                    
                                ) : (
                                    <div className="MyBetsSingleBetRow">
                                        <div className='MyBetsSingleBetReturnType GrayColour'>EST. RETURN</div>
                                        <div 
                                            className='MyBetsSingleBetReturnAmount MyBetsSingleBetReturnEstimatedReturn'
                                            data-test-selector="Text__BetEstimatedReturns"
                                        >{estimatedReturnsValue}</div>
                                    </div>
                                )
                            }
                        </div>
                        
                        <div className="MyBetsSingleBetColumn MyBetsSingleBetReceiptDetails FromMedium">
                            <div 
                                className='Secondary900 FontSizeSmall'
                                data-test-selector="Text__BetTimePlaced"
                            >Bet Placed at {timePlaced}</div>
                            <div 
                                className='ReceiptNumber'
                                data-test-selector="Text__BetReceiptId"
                            >
                                <span className='GrayColour'>receipt no</span>
                                <span className='Bold'>{this.props.receiptId}</span> 
                            </div>  
                        </div>
                    </div>

                    <div className="MyBetsSingleBetColumn MyBetsSingleBetReceiptDetails ToMedium">
                        <div 
                            className='Secondary900 FontSizeSmall'
                            data-test-selector="Text__BetTimePlaced"
                        >Bet Placed at {timePlaced}</div>
                        <div 
                            className='ReceiptNumber'
                            data-test-selector="Text__BetReceiptId"    
                        >
                            <span className='GrayColour'>receipt no</span>
                            <span className='Bold'>{this.props.receiptId}</span> 
                        </div>
                    </div>
                </div>

                {/* Mobile view */}
                <div className="MyBetsSingleBetContainer MyBetsSingleBetContainerMobileLayout">
                    <div className="MyBetsSingleBet">
                        {/* Mobile Bet Details */}
                        <div className="MyBetsSingleBetRow MobileBetDetailsContainer MobileBetLayout">
                            <div 
                                className='BookmakerLogo'
                                data-test-selector="Logo__BetHistoryBookmaker"
                            >
                                {bookmakerName === "skybet" ? (
									<img alt='skybet' src='/svgs/bookmaker-logos/skybet-square.svg' />
								) : 
                                    <Svg iconName={`${bookmakerName}-small-square`} className='ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'/>
                                }
                            </div>

                            <div className="MobileBetDetails">
                                <div className="MyBetMobileLayoutRow">
                                    <div>
                                        {
                                            selections.length > 1 ? (
                                                <div>
                                                    <div 
                                                        className='FontCapitalize Bold'
                                                        data-test-selector="Text__BetName"    
                                                    > {betName} </div>
                                                    <div
                                                        className={
                                                            classNames('MultipleSelectionsToggle',
                                                            { [this.state.isToggled && 'isToggled']: this.state.isToggled })
                                                        }
                                                        onClick={() => this.onToggleDropdown()}
                                                        data-test-selector="Button__ToggleMultipleBetSelections"
                                                    >
                                                        <div className='ToggleHandle'>
                                                        { this.state.isToggled ? (
                                                            <Fragment>
                                                                <Svg
                                                                    key='mobile-eye-closed'
                                                                    iconName="eye-closed"
                                                                    className='ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
                                                                />
                                                                close selections
                                                            </Fragment>
                                                        ) : (
                                                            <Fragment>
                                                                <Svg
                                                                    key='mobile-eye'
                                                                    iconName="eye"
                                                                    className='ui-icon bs-icon_sizeSmallMedium MultipleSelectionsToggle__Icon'
                                                                />
                                                                view selections
                                                            </Fragment>
                                                        )
                                                    }
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                <div>
                                                    <div 
                                                        className='FontSizeLarge Bold'
                                                        data-test-selector="Text__BetNameAndOdds"    
                                                    >{selections[0].selectionName} {getOddsLabel(selections[0].odd)}</div>
                                                    <div 
                                                        data-test-selector="Text__BetEventName"
                                                    >{selections[0].eventName}</div>
                                                </div>
                                            )
                                        }
                                    </div>

                                    <div className='MobileBetData' data-test-selector="Text__BetStatus">
                                        {
                                            finished ? (
                                                win ? (
                                                    <Fragment>
                                                        <div 
                                                            className='BetStatus Bold700 Won'
                                                            data-test-selector="Text__BetWin"
                                                        >WON</div>
                                                        <div 
                                                            className='Bold'
                                                            data-test-selector="Text__BetReturns"
                                                        >
                                                            +{returnsValue}
                                                        </div>
                                                    </Fragment>
                                                ) : (
                                                    <Fragment>
                                                        <div 
                                                            className='BetStatus Bold700 Lost'
                                                            data-test-selector="Text__BetLost"
                                                        >LOST</div>
                                                        <div 
                                                            className='Bold'
                                                            data-test-selector="Text__BetTotalStakeValue"
                                                        >
                                                            -{totalStakeValue}
                                                        </div>
                                                    </Fragment>
                                                )
                                            ) : (
                                                <Fragment>
                                                    <div 
                                                        className='BetStatus Bold700 Open'
                                                        data-test-selector="Text__BetStatus"    
                                                    >OPEN</div>
                                                    <div 
                                                        className='Bold'
                                                        data-test-selector="Text__BetEstimatedReturns"
                                                    >
                                                        {totalStakeValue}
                                                    </div>
                                                </Fragment>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Multi-bet */}
                        <div className='MyBetsSingleBetType MyBetsSingleBetColumn'>
                            {
                                selections.length > 1 && (
                                    <div 
                                        className="MultipleSelections"
                                        data-test-selector="Container__BetMultipleSelections"
                                    >
                                        {this.state.isToggled && (
                                            <div className="RacesContainer">
                                                {
                                                    selections.map((selection, index) => (
                                                        <div key={`mobile-${index}`} className="RaceDetails">
                                                            <div className='HorseDetails'>
                                                                <span 
                                                                    className='HorseName Bold'
                                                                    data-test-selector="Text__BetSelectionName"
                                                                >
                                                                    {selection.selectionName}
                                                                </span>
                                                                <span 
                                                                    className='GrayColour FontSizeMedium Bold'
                                                                    data-test-selector="Text__BetSelectionOdds"    
                                                                >{getOddsLabel(selection.odd)}</span>
                                                            </div>
                                                            
                                                            <div 
                                                                className='EventName'
                                                                data-test-selector="Text__BetSelectionEvent"    
                                                            > {selection.eventName} - {formatDate(selection.eventDateTime)}</div>
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                        )}
                                    </div>
                                )
                            }
                        </div>

                        {/* Mobile Receipt Details */}
                        <div className="MyBetsSingleBetRow MobileReceiptContainer MobileBetLayout FontSizeSmall">
                            <div 
                                className="MyBetMobileLayoutRow"
                                data-test-selector="Text__BetReceiptId"    
                            >
                                <div>Receipt ID</div>
                                <div>{receiptId}</div>
                            </div>
                            <div 
                                className="MyBetMobileLayoutRow"
                                data-test-selector="Text__BetTimePlaced"    
                            >
                                <div>Time bet placed</div>
                                <div>{timePlaced}</div>
                            </div>
                            <div 
                                className="MyBetMobileLayoutRow"
                                data-test-selector="Text__BetType"    
                            >
                                <div>Bet Type</div>
                                <div className='FontCapitalize'>{betName}</div>
                            </div>
                            <div 
                                className="MyBetMobileLayoutRow"
                                data-test-selector="Text__BetTotalStakeAndPotentialReturn"    
                            >
                                {
                                    finished ? (
                                        <Fragment>
                                            <div>Total stake</div>
                                            <div> {totalStakeValue}</div>
                                        </Fragment>
                                    ) : (
                                        <Fragment>
                                            <div>Potential return</div>
                                            <div>
                                            {estimatedReturnsValue}</div>
                                        </Fragment>
                                    )
                                }
                            </div>
                        </div>

                        <div className="MyBetsSingleBetColumn MyBetsSingleBetReceiptDetails FromMedium">
                            <div 
                                className='Secondary900 FontSizeSmall'
                                data-test-selector="Text__BetTimePlaced"
                            >
                                Bet Placed at {timePlaced}
                            </div>
                            <div 
                                className='ReceiptNumber'
                                data-test-selector="Text__BetReceiptId"
                            >
                                <span className='GrayColour'>receipt</span>
                                <span className='Bold'>{receiptId}</span> 
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

BetHistoryListItem.defaultProps = {
    win: null,
    returns: 0,
};

BetHistoryListItem.propTypes = {
    finished: PropTypes.bool.isRequired,
    receiptId: PropTypes.string.isRequired,
    timeBetPlaced: PropTypes.string.isRequired,
    betType: PropTypes.string.isRequired,
    stake: PropTypes.number.isRequired,
    totalStake: PropTypes.number.isRequired,
    returns: PropTypes.number,
    currencySign: PropTypes.string.isRequired,
    win: PropTypes.bool,
    selections: PropTypes.arrayOf(PropTypes.shape({
        eachWay: PropTypes.bool.isRequired,
        eventName: PropTypes.string.isRequired,
        odd: PropTypes.string.isRequired,
        selectionName: PropTypes.string.isRequired,
    })).isRequired,
    bookmakerName: PropTypes.string.isRequired,
    estimatedReturns: PropTypes.number.isRequired
};

export default BetHistoryListItem


// WEBPACK FOOTER //
// /src/js/BetHistory/components/BetHistoryListItem.jsx